export default function CFor() {
  return <h2>C For</h2>;
}
